/* eslint-disable camelcase */
import { FC } from 'react'
import { Create, SimpleForm, TextInput } from 'react-admin'
import { useLocation } from 'react-router-dom'
import { ToolFormFields } from '../../components'

const isProxyState = (value: unknown): value is { proxyId?: string } =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

const ProxyToolCreate: FC = () => {
  const location = useLocation()
  const state = isProxyState(location.state) ? location.state : undefined
  const proxyId = state?.proxyId ?? ''

  return (
    <Create redirect={proxyId ? `/proxy/${proxyId}/show/tools` : 'list'}>
      <SimpleForm defaultValues={{
        proxy_id: proxyId,
        http_method: 'GET',
        parameters: [],
      }}>
        <TextInput source="proxy_id" label="data.proxyId" fullWidth disabled />
        <ToolFormFields />
      </SimpleForm>
    </Create>
  )
}

export default ProxyToolCreate
